// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"648":"6175d229","3340":"6677173c","6218":"6175d229"}[chunkId] + ".chunk.css";
};